import React, { Component } from 'react';
import _ from 'lodash';
import {
    getPayouts as fetchPayouts,
    fetchUrl
} from './payoutsActions';
import {
    getPayouts,
    getCount,
    getPages,
    getPayoutsErrorMessage,
    getIsPayoutsLoading,
    getHasMore
} from './payoutsEntity';
import PayoutStatusFilter from '../Table/Filters/PayoutStatusFilter/PayoutStatusFilter';
import PayoutListItem from './PayoutListItem/PayoutListItem';
import { transformDateCell } from '../../utils/cell';
import Table from '../Table/Table';
import {
    dataTransform,
    payoutProviderMapper,
    transferStatusMapper
} from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { selectPayout } from './payoutsActions';
import { getSelectedPayoutAccountIdsString } from '../PayoutAccountSelector/payoutAccountSelectorViewState';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { getColumnsByUniqueTableName } from '../Table/tableEntity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { toggleModal } from '../Modal/modalActions';
import './Payouts.scss';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';
import FilterWithMapper from '../Table/Filters/FilterWithMapper/FilterWithMapper';
import CurrencyCodeFilter from '../Table/Filters/CurrencyCodeFilter/CurrencyCodeFilter';
import AmountFilter from '../Table/Filters/AmountFilter/AmountFilter';
import { prettifyMoney } from '@nexio/emvio-util-app';

export class Payouts extends Component {
    dateKey = 'payoutDate';

    static propTypes = {
        selectedPayoutAccountIds: PropTypes.string,
        onToggleModal: PropTypes.func.isRequired,
        columns: PropTypes.array,
        payoutAccountMap: PropTypes.any,
        timezone: PropTypes.string,
        isAdmin: PropTypes.bool,
        isForPayoutRecipientTable: PropTypes.bool,
        recipientId: PropTypes.number,
        uniqueTableName: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'amount',
                Cell: (props) => `${prettifyMoney(props.value, props.original.currency)}`,
                className: ['right-justify', 'cursor-pointer'],
                Filter: ({ filter, onChange }) => (<AmountFilter filter={filter} onChange={onChange} />),
                label: 'Amount',
                minWidth: 120,
                show: true,
                sortable: false
            },
            {
                accessor: 'batchRef',
                className: ['cursor-pointer'],
                label: 'Batch Ref',
                minWidth: 250,
                show: true,
                sortable: false
            },
            {
                accessor: 'country',
                className: ['cursor-pointer'],
                label: 'Country',
                minWidth: 110,
                show: true,
                sortable: true,
                filterable: true
            },
            {
                accessor: 'currency',
                transformData: dataTransform.uppercase,
                Filter: ({ filter, onChange }) => (<CurrencyCodeFilter
                    filter={filter}
                    onChange={onChange}
                    allowAllCurrencies
                    shouldUseCurrencyCodeAsValue />
                ),
                className: ['cursor-pointer'],
                label: 'Currency',
                minWidth: 75,
                show: true,
                sortable: false
            },
            {
                accessor: 'email',
                className: ['cursor-pointer'],
                label: 'Email',
                minWidth: 175,
                show: true,
                sortable: false
            },
            {
                accessor: 'firstName',
                className: ['cursor-pointer'],
                label: 'First Name',
                minWidth: 120,
                show: true,
                sortable: false
            },
            {
                accessor: 'lastName',
                className: ['cursor-pointer'],
                label: 'Last Name',
                minWidth: 125,
                show: true,
                sortable: false
            },
            {
                accessor: 'payoutAccountId',
                transformData: (data) => `${data.original.payoutAccountId} - ${this.props.payoutAccountMap[data.original.payoutAccountId]}`,
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper filter={filter}
                        mapper={this.getPayoutAccountsDropDown()}
                        onChange={onChange}
                    />
                ),
                className: ['cursor-pointer'],
                label: 'Payout Account',
                minWidth: 250,
                show: true,
                sortable: true
            },
            {
                accessor: 'payoutDate',
                Cell: transformDateCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Payout Date',
                minWidth: 130,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'payoutProviderAdditionalRef',
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Payout Provider Additional Reference',
                minWidth: 275,
                show: false,
                sortable: false
            },
            {
                accessor: 'payoutProviderRef',
                className: ['cursor-pointer'],
                label: 'Payout Provider Reference',
                minWidth: 205,
                show: true,
                sortable: false
            },
            {
                accessor: 'payoutRef',
                className: ['cursor-pointer'],
                label: 'Payout Reference',
                minWidth: 140,
                show: true,
                sortable: false
            },
            {
                accessor: 'payoutStatus',
                transformData: dataTransform.payoutStatusMapper,
                Filter: ({ filter, onChange }) => (
                    <PayoutStatusFilter
                        filter={filter}
                        onChange={onChange}
                    />
                ),
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Payout Status',
                minWidth: 115,
                show: true,
                sortable: false
            },
            {
                accessor: 'transferStatus',
                transformData: dataTransform.transferStatusMapper,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper
                        filter={filter}
                        mapper={transferStatusMapper}
                        onChange={onChange}
                    />
                ),
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Transfer Status',
                minWidth: 125,
                show: true,
                sortable: false
            },
            {
                accessor: 'phoneNumber',
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Phone Number',
                minWidth: 150,
                show: false,
                sortable: false
            },
            {
                accessor: 'providerId',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Provider ID',
                minWidth: 90,
                show: true,
                sortable: false
            },
            {
                accessor: 'providerRecipientRef',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Provider Recipient Reference',
                minWidth: 220,
                show: true,
                sortable: false
            },
            {
                accessor: 'recipientId',
                filterable: this.props.isForPayoutRecipientTable ? false : true,
                className: ['cursor-pointer'],
                label: 'Recipient ID',
                minWidth: 90,
                show: true,
                sortable: false
            },
            {
                accessor: 'recipientRef',
                filterable: true,
                className: ['cursor-pointer'],
                label: 'Recipient Reference',
                minWidth: 150,
                show: true,
                sortable: false
            },
            {
                label: 'Payout Provider Name',
                accessor: 'providerType',
                transformData: dataTransform.payoutProviderMapper,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper
                        filter={filter}
                        mapper={payoutProviderMapper}
                        onChange={onChange}
                    />
                ),
                filterable: true,
                className: ['cursor-pointer'],
                minWidth: 160,
                show: true,
                sortable: false
            }
        ];
    }

    fetchData = (filters, page, pageSize, sorters, merchantIds, columns) => {
        if (this.props.isForPayoutRecipientTable && this.props.recipientId) {
            filters.push({ id: 'recipientId', value: this.props.recipientId });
        }

        return fetchPayouts(filters, page, pageSize, sorters, this.props.selectedPayoutAccountIds, columns);
    };

    renderHeaderComponent = () => {
        return (
            <div className="payout-table-header">
                {this.props.isAdmin ? <span className="material-icons" title="Upload Payout Batch" onClick={() => this.props.onToggleModal('uploadPayouts')}>upload_file</span> : null}
            </div>
        );
    };

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    getPayoutAccountsDropDown = () => {
        const result = {};
        _.forEach(this.props.payoutAccountMap, (value, key) => {
            result[key] = `${key} - ${value}`;
        });

        return result;
    };

    render() {
        return (
            <div className="emvio-payouts">
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-payouts-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: this.dateKey
                    }]}
                    fetchData={this.fetchData}
                    countSelector={getCount}
                    dataSelector={getPayouts}
                    selectRow={selectPayout}
                    errorMessageSelector={getPayoutsErrorMessage}
                    isDataLoadingSelector={getIsPayoutsLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    hasNoCount={true}
                    HeaderComponent={this.props.isForPayoutRecipientTable ? null : this.renderHeaderComponent}
                    ListItemComponent={PayoutListItem}
                    noDataText="No Payouts Found"
                    uniqueTableName={this.props.uniqueTableName || 'Payouts'}
                    getTableState={this.getTableState}
                    hasMoreSelector={getHasMore}
                    filterable={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'Payouts'),
        payoutAccountMap: getPayoutAccountsMapper(state),
        isAdmin: getIsUserAnAdmin(state)
    };
}

function mapDispatchToProps(dispatch) {
    return { onToggleModal: () => dispatch(toggleModal('uploadPayouts')) };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Payouts));
